import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "mobile-footer",
  hidden: ""
}
const _hoisted_4 = { class: "center-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
    close: _ctx.closeModal,
    onBeforeEnter: _ctx.fixBody,
    onAfterLeave: _ctx.unfixBody
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["modal", [_ctx.customClasses]])
      }, [
        _createElementVNode("header", null, [
          _createElementVNode("button", {
            class: "close-btn",
            title: _ctx.pageTexts['hotelPageGeneralModalButtonClose'],
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_1),
          _createElementVNode("h2", null, [
            _renderSlot(_ctx.$slots, "headerText")
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonBack']), 1)
          ])
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue", "close", "onBeforeEnter", "onAfterLeave"]))
}